import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";
import Description from './Description.jsx';
import Hero from './Hero.jsx';
import NavBar from './NavBar.jsx';
import Services from './Services.jsx';
import Footer from './Footer.jsx';
import Quote from "./Quote.jsx";
import SiteText from "./SiteText.jsx";
import ScrollToTop from "./ScrollToTop.jsx";
import ServiceDescription from "./ServiceDescription.jsx";


function TrackPreviousRoute() {
  const location = useLocation();
  const prevLocation = useRef(null);

  useEffect(() => {
    // store previous path in sessionStorage
    if (prevLocation.current) {
      sessionStorage.setItem("previousRoute", prevLocation.current.pathname);
    }
    prevLocation.current = location;
  }, [location]);

  return null; // this component just tracks route changes
}

function Main() {
  return <>
    <title>{SiteText.Global.Name}</title>
    <NavBar/>
    <div className="h-32"/>
    <Hero />  
    <Description/>
    <Services />
    <Footer />
  </>
}

function About() {
  return <>
    <title>{SiteText.Global.Name}</title>
    <NavBar />
    <div className="h-32"/>
    <Description/>
    <Footer />
  </>
}

function Contact() {
  return <>
    <title>{SiteText.Global.Name}</title>
    <NavBar />
    <div className="h-32"/>
    <Quote />
    <Footer />
  </>
}

function ServiceDetail(){
  return <>
    <title>{SiteText.Global.Name}</title>
    <NavBar />
    <div className="h-32" />
    <ServiceDescription />
    <Footer />
  </>
}

function App() {
  return(
    <Router>
      <TrackPreviousRoute />
      <ScrollToTop />
      <Routes>
        <Route path={SiteText.SitePaths.Home} element={<Main />} />
        <Route path={SiteText.SitePaths.About} element={<About />} />
        <Route path={SiteText.SitePaths.GetQuote} element={<Contact />} />
        <Route path={SiteText.SitePaths.ServiceId} element={<ServiceDetail />} />
      </Routes>
    </Router>
  )
};

export default App;
